import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { Detail } from 'app/interfaces/detail.model';
import { DetailService } from 'app/modules/project/services/detail.service';

@Component({
  selector: 'app-detail-form-inline',
  templateUrl: './detail-form-inline.component.html',
  styleUrls: ['./detail-form-inline.component.scss'],
})
export class DetailFormInlineComponent implements OnInit, OnChanges {
  private _detail: Detail;
  saving: boolean = false;

  @Input() set detail(value: Detail) {
    this._detail = value;
    this.updateSelectFields();
  }

  get detail(): Detail {
    return this._detail;
  }

  @Input() elements: any[];
  @Input() materials: any[];
  @Input() structures: any[];

  @Output() onSave: EventEmitter<Detail> = new EventEmitter<Detail>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() onDelete: EventEmitter<Detail> = new EventEmitter<Detail>();

  selectedElements: Array<any> = [];
  selectedStructures: Array<any> = [];
  selectedMaterials: Array<any> = [];

  constructor(private _detailService: DetailService) {}

  ngOnInit() {}

  // Make sure our original detail is kept intact
  ngOnChanges(changes: SimpleChanges) {
    if (changes.detail) {
      this.detail = Object.assign({}, changes.detail.currentValue);
    }
  }

  updateSelectFields() {
    this.selectedStructures = this.detail.Structures.map(a => {
      return { id: a.Id, text: a.Name };
    });
    this.selectedMaterials = this.detail.Materials.map(a => {
      return { id: a.Id, text: a.Name };
    });
    this.selectedElements = this.detail.Categories.map(a => {
      return { id: a.Id, text: a.Name };
    });
  }

  /*
   * Update ngSelect for materials, details, concepts and structures
   */
  updateNgSelect(event, index) {
    this.detail[index] = event.map(d => {
      return { Id: d.id, Name: d.text };
    });
  }

  save() {
    this._detailService.save(this.detail).subscribe((a: any) => {
      this.detail = a.Project;
      this.onSave.emit(this.detail);
    });
  }

  compareFn(val1, val2): boolean {
    return val1 && val2 ? val1.Id === val2.Id : val1 === val2;
  }
}
